
import { Button} from '@/imports-files/components/confirmation-modal';
import  ComponentStyle from '@/styles/components/delete-candidate-modal/_index.module.scss';
import { closeJob}  from '@/imports-files/pages/clients/candidates/kanban';

export function HiredModal({setHiredModal, router, job_id, t})
{
  return(
          <div className = {`CandidateFilterModal ${ComponentStyle.DeleteCandidateModal}`}>
            <div className={ComponentStyle.DeleteCandidateModal__Inner}>
              <div className={ComponentStyle.DeleteCandidateModal__Container}>
                  <span className={`normalweight ${ComponentStyle.DeleteCandidateModal__Message}`}>{t('modal:close_job_modal_text')}</span>
                  <div className={ComponentStyle.DeleteCandidateModal__ButtonSection}>
                    <Button buttonstyle={ComponentStyle.primarybtn} onClick={()=> {closeJob(job_id, router)}}>{t('modal:close_job_button')}</Button>
                    <Button buttonstyle={ComponentStyle.secondarybtn} onClick={()=> setHiredModal(false)}>{t('modal:continue_hiring')}</Button>
                  </div>
              </div>
            </div>
          </div>
        )
} 

